import {
  fetch1BCreditReportById,
  fetch3BCreditReportById,
  fetchCreditReport,
  fetchCreditReportDiscrepancies,
  fetchUpdateDiscrepancy,
} from 'externals/_services/creditReport.service';

import { wrapService } from 'actions/service_wrapper.actions';
import { SET_DISCREPANCIES } from 'types/disputes.constants';
import { creditReportTUConstants } from 'pages_CreditReportTU_constants/creditReportTU.constants';

const a_fetchCreditReport = wrapService(fetchCreditReport, {
  name: 'fetchCreditReport',
});

const a_fetch3BCreditReportById = wrapService(fetch3BCreditReportById, {
  name: 'fetch3BCreditReportById',
});

const a_fetch1BCreditReportById = wrapService(fetch1BCreditReportById, {
  name: 'fetch1BCreditReportById',
});

const a_fetchCreditReportDiscrepancies = wrapService(
  fetchCreditReportDiscrepancies,
  {
    name: 'fetchCreditReportDiscrepancies',
  },
);

const a_fetchUpdateDiscrepancy = wrapService(fetchUpdateDiscrepancy, {
  name: 'fetchUpdateDiscrepancy',
});

export const getCreditReport = () => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(a_fetchCreditReport())
      .then(response => {
        dispatch(storeCreditReports(response));
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const get3BCreditReport = reportId => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(a_fetch3BCreditReportById(reportId))
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const get1BCreditReport = reportId => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(a_fetch1BCreditReportById(reportId))
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getCreditReportDiscrepancies = (reportId, body) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(a_fetchCreditReportDiscrepancies(reportId, body))
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateCreditReportDiscrepancy = body => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(a_fetchUpdateDiscrepancy(body))
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const storeDiscrepancies = (reportId, discrepancies) => ({
  type: SET_DISCREPANCIES,
  reportId,
  discrepancies,
});

export const storeCreditReports = creditReports => ({
  type: creditReportTUConstants.STORE_REPORTS,
  creditReports,
});
